import type { ParsedCvData } from "@tabbio/types";
import {
  assessParsedCvForReplacement,
  buildSaveSectionsFromParsedCvData,
  ImportedCvIncompleteError,
} from "./cv-save-sections";

/** The import review is shared; its persistence destination must be explicit. */
export async function persistCvResumeReplacement(
  input: {
    parsed: ParsedCvData;
    importEvidenceId?: string;
    tailoredCvId?: string;
    target?: string | null;
    expectedUpdatedAt?: string | null;
  },
  writers: {
    replaceTailored: (
      id: string,
      data: {
        parsed: ParsedCvData;
        importEvidenceId?: string;
        expectedUpdatedAt: string;
        replacementConfirmed: true;
      },
    ) => Promise<unknown>;
    saveProfile: (
      data: ReturnType<typeof buildSaveSectionsFromParsedCvData> & {
        source: ParsedCvData;
        importEvidenceId?: string;
        replacementConfirmed: true;
      },
    ) => Promise<unknown>;
  },
) {
  if (input.tailoredCvId) {
    if (!input.expectedUpdatedAt) throw new Error("CV revision unavailable");
    // The targeted writer bypasses the profile payload builder, so enforce
    // the same import evidence gate explicitly before either API is called.
    const assessment = assessParsedCvForReplacement(input.parsed);
    if (!assessment.hasMeaningfulEvidence)
      throw new ImportedCvIncompleteError(assessment);
    return writers.replaceTailored(input.tailoredCvId, {
      parsed: input.parsed,
      importEvidenceId: input.importEvidenceId,
      expectedUpdatedAt: input.expectedUpdatedAt,
      replacementConfirmed: true,
    });
  }
  if (input.target && input.target !== "master")
    throw new Error("Unsupported profile replacement target");
  return writers.saveProfile({
    ...buildSaveSectionsFromParsedCvData(input.parsed, {
      replaceExisting: true,
    }),
    replacementConfirmed: true,
    source: input.parsed,
    importEvidenceId: input.importEvidenceId,
  });
}
